import { juntarHistorico } from "./abertura"
import type { ChatMessage, Entry } from "./types"

/**
 * O que o socket nao entregou, buscado no historico e posto no lugar certo.
 *
 * O evento ao vivo sai da instancia do chatbot que PROCESSOU a mensagem, e a
 * sala do socket.io mora na memoria da instancia em que o visitante CONECTOU.
 * Com duas instancias no ar — todo deploy sobrepoe a revisao velha e a nova, e
 * as duas puxam do mesmo Pub/Sub —, a resposta do fluxo nascia na instancia
 * errada e nunca chegava. Ela estava gravada: aparecia so recarregando a pagina.
 *
 * Onde cada linha entra e a MESMA regra da abertura da conversa
 * (`juntarHistorico`): na ordem do servidor, sem repetir o que ja esta na tela,
 * trocando o eco local pela versao do servidor e sem trazer a saudacao para o
 * meio da conversa. Uma regra so — a busca de resgate e a abertura veem o mesmo
 * historico e nao podem arrumar a tela de jeitos diferentes.
 *
 * Nada a acrescentar devolve a MESMA lista, para a tela nao redesenhar a toa.
 */
export function recuperarDoHistorico(tela: Entry[], historico: ChatMessage[]): Entry[] {
  if (!historico.length) return tela
  return juntarHistorico(
    tela,
    historico.map((message) => ({ kind: "message" as const, message })),
  )
}
